





import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/auth';

@Component
export default class PermissionAuth extends BaseComponent {
  @Prop(Array)
  public requiredPermissions?: string[];

  @Prop(Boolean)
  public keepDisabled?: boolean;

  public userPermissions: string[] = [];

  public show(): boolean {
    return this.hasPermission() || this.keepDisabled;
  }

  public hasPermission(): boolean {
    if (!!this.userPermissions.length) {
      return service.checkUserPermissions(
        this.requiredPermissions,
        this.userPermissions,
      );
    } else {
      return service.checkUserPermissions(this.requiredPermissions);
    }
  }
}
